import { useState, useEffect } from 'react'
import styled from 'styled-components'
import Overlay from 'common/Overlay'

const FadeStyled = styled.div`
  animation: ${({ show }) => (show ? 'bounceInDown' : 'bounceOutUp')} 1s;
  animation-fill-mode: forwards;
  .animation-container {
    block-size: 100vh;
  }

  @keyframes bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0) scaleY(3);
    }

    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0) scaleY(0.9);
    }

    75% {
      transform: translate3d(0, -10px, 0) scaleY(0.95);
    }

    90% {
      transform: translate3d(0, 5px, 0) scaleY(0.985);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0) scaleY(0.985);
    }

    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0) scaleY(0.9);
    }

    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0) scaleY(3);
    }
  }
`

function AnimatedModal({ show, children }) {
  const [shouldRender, setRender] = useState(show)

  useEffect(() => {
    if (show) setRender(true)
  }, [show])

  const onAnimationEnd = () => {
    if (!show) setRender(false)
  }

  return (
    shouldRender ? (
      <Overlay zIndex={10} isActive background={show ? 'rgb(31, 31, 58, 0.5)' : 'transparent'} noFilter={!show}>
        <FadeStyled show={show} onAnimationEnd={onAnimationEnd}>
          <div className="animation-container">
            {children}
          </div>
        </FadeStyled>
      </Overlay>
    ) : null
  )
}

export default AnimatedModal
